import React, { useState } from "react";
import VideoPopup from "../../common/Modals/VideoPopup";

const RepairandServiceDetails = () => {
  const [isVideoOpen,setIsVideoOpen] = useState(false);
  return (
    <>
      <div className="tp-service-page pt-140 pb-140">
        <div className="container">
          <div className="row pb-30">
            <div className="col-lg-6 mb-30">
              <div className="tp-sv-inner-img w-img">
                <img src="/assets/img/service/service-repair1.jpg" alt="" />
              </div>
            </div>
            <div className="col-lg-6 mb-30">
              <div className="tp-sv-inner-img w-img">
                <img src="/assets/img/service/service-repair2.jpg" alt="" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="tp-sv__content">
                <h3 className="tp-sv__title">Elevator Repair & Service</h3>
                <p>
                Lumetiq Elevators Pvt Ltd provides expert repair and maintenance 
                  services to ensure the smooth and safe operation of your elevators. 
                  Our team is equipped to handle routine maintenance, emergency repairs, 
                  and comprehensive service plans tailored to your needs.{" "}
                </p>

                <p>
                Whether it’s addressing mechanical failures, electrical issues, or 
                  wear and tear, we offer fast and reliable solutions to minimize 
                  downtime and keep your elevators running efficiently.
                </p>

                <h4 className="tp-sv__subtitle">
                Reliable Maintenance & Quick Repairs
                </h4>
                <p>
                Our repair services cover everything from replacing faulty components 
                  to troubleshooting complex system malfunctions. We use high-quality 
                  parts and advanced diagnostic tools to restore optimal performance.
                </p>
                <p>
                With preventive maintenance plans, we help you avoid unexpected 
                  breakdowns and extend the lifespan of your elevators. Our commitment 
                  to safety and efficiency ensures that your equipment remains in top condition.
                </p>

                <p>
                Trust Lumetiq Elevators Pvt Ltd for professional repair and service 
                  solutions that keep your elevators safe, reliable, and efficient.
                </p>

                <div className="tp-sv__video">
                  <div
                    className="tp_sv__video-bg"
                    // data-background="/assets/img/service/service-blog-bg.jpg"
                    style={{
                      backgroundImage: `url("/assets/img/service/service-blog-bg.jpg")`,
                    }}
                  >
                    {/* <div className="pt-180 pb-180 text-center p-relative">
                      <span>
                        <button
                          onClick={()=> setIsVideoOpen(true)}
                          className="sv-video sv-popup-video"
                        >
                          <i className="fas fa-play"></i>
                        </button>
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* video modal start */}
      <VideoPopup
        isVideoOpen={isVideoOpen}
        setIsVideoOpen={setIsVideoOpen}
        videoId={"EW4ZYb3mCZk"}
      />
      {/* video modal end */}
    </>
  );
};

export default RepairandServiceDetails;
